import moment from 'moment'

const getLastWorkingDay = function () {
  const workday = moment()
  const day = workday.day()
  let diff = 1 // yesterday
  if (day === 0 || day === 1) { // is Sunday or Monday
    diff = day + 2 // returns Friday
  }
  workday.subtract(diff, 'days')
  return workday
}

export { getLastWorkingDay }
